var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.5001L21.4675 19.4676C20.666 18.6661 20.6902 17.3592 21.5209 16.5878L22.0995 16.0505C22.883 15.323 24.1003 15.3404 24.8627 16.0901L37.0498 28.074C37.8467 28.8577 37.8467 30.1424 37.0498 30.9261L24.9023 42.8712C24.124 43.6364 22.8759 43.6364 22.0977 42.8712L21.4502 42.2345C20.6532 41.4508 20.6532 40.166 21.4502 39.3824L31.5 29.5001Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.34b12cd518b062620cc78e79d226dac7.svg";
export { ForwardRef as ReactComponent };